import { Stack, StyleProps } from '@chakra-ui/react'
import { themeColors } from 'theme'

type CustomDividerProps = StyleProps & { orientation?: boolean }

const CustomDivider: React.FC<CustomDividerProps> = ({ orientation = false, ...props }) => {
  const { divider: { primaryColor } } = themeColors

  return (
    <Stack w={orientation ? '2px' : '90%'} my={2} h={orientation ? '350px' : '2px'} mx='auto' bg={primaryColor} {...props} />
  )
}

export default CustomDivider
